import Vue from 'vue'
import Vuex from 'vuex'
import { state, mutations } from './mutations'
import plugins from './plugins'
import getters from './getters'
import actions from './actions'

// modules
import {default as processes, processesPlugin} from './modules/processes'
import { s3uploader } from './modules/s3uploader'

Vue.use(Vuex)

export default new Vuex.Store({
  state,
  mutations,
  plugins,
  getters,
  actions,
  modules: {
    processes: processes,
    s3uploader: s3uploader
  },
  plugins: [processesPlugin()]
})
